export const environment = {
  production: true,
  posthogApiKey: "phc_EbG4I7qUHJmKlYzcfssdywQo250c5l41Wojg7boNb01",
  posthogApiHost: "https://us.i.posthog.com",
  stripePremiumPlanProductId: "prod_Ps2hDNfL8y8K7F",
  stripeCompletePlanProductId: "prod_SgM8IbBZCFhLfB",
};
